<template>
  <i-drawer
    :visible="show"
    side="left"
    class="document-switcher-panel"
    title="Switch Document"
    @hide-drawer="$emit('hide-drawer')"
  >
    <i-breadcrumbs
      :items="breadcrumbs"
      class="i-mb-8"
      size="md"
      data-testid="document-switcher-breadcrumbs"
    >
    </i-breadcrumbs>

    <div class="document-cards-list">
      <document-card
        v-for="docItem in documentList"
        :key="docItem.id"
        :document="docItem"
        data-testid="document-switcher-item"
        size="small"
        :show-checks="false"
        :show-tags="false"
        :return-to="returnToPath"
        @on-right-icon-click="viewDocument(docItem)"
        @on-document-click="viewDocument(docItem)"
      />
    </div>
    <template #footer>
      <i-button
        text="View Customer"
        class="view-customer-button"
        :type="iButtonTypes.NEUTRAL"
        :button-style="iButtonStyles.SOLID_LIGHT"
        :size="iButtonSizes.LARGE"
        @button-click="viewCustomer"
      ></i-button>
    </template>
  </i-drawer>
</template>

<script>
import {
  iBreadCrumbs,
  iButton,
  iButtonTypes,
  iButtonStyles,
  iButtonSizes,
  iDrawer,
} from '@inscribe/signal';
import DocumentCard from '@/V2/components/documents/DocumentCard';
import { mapGetters } from 'vuex';

export default {
  components: {
    DocumentCard,
    'i-breadcrumbs': iBreadCrumbs,
    iButton,
    iDrawer,
  },
  props: {
    document: {
      type: Object,
      required: true,
    },
    customer: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      breadcrumbs: [
        {
          icon: 'medium_home_1',
          clickCallbackFn: () => {
            this.showRoute({
              name: 'customers-view',
            });
          },
        },
        {
          label: this.customer.name,
          clickCallbackFn: () => {
            this.showRoute({
              name: 'customer-overview',
              params: {
                customer_id: this.$route.params.customer_id,
              },
            });
          },
        },
        {
          label: 'Documents',
          clickCallbackFn: () => {
            this.showRoute({
              name: 'customer-overview',
              params: {
                customer_id: this.$route.params.customer_id,
              },
            });
          },
        },
      ],
      iButtonTypes,
      iButtonStyles,
      iButtonSizes,
    };
  },
  computed: {
    ...mapGetters(['getCachedFirstPageOfSummaryDocumentsForCustomerUUID']),
    customerId() {
      return this.$route.params.customer_id;
    },
    returnToPath() {
      return this.$route.fullPath;
    },
    documentList() {
      return this.getCachedFirstPageOfSummaryDocumentsForCustomerUUID(
        this.customerId,
      );
    },
  },
  watch: {
    $route() {
      this.$emit('hide-drawer');
    },
  },
  methods: {
    showRoute(route) {
      this.$emit('hide-drawer');
      setTimeout(() => {
        this.$router.push(route);
      });
    },
    viewCustomer() {
      this.$router.push({
        name: 'customer-overview',
        params: {
          customer_id: this.customerId,
        },
      });
    },
    viewDocument(document) {
      this.$router.push({
        name: 'document-signals',
        params: {
          customer_id: document.customer_id,
          document_id: document.id,
        },
        query: {
          return_to: this.returnToPath,
        },
      });
      this.$emit('hide-drawer');
    },
  },
};
</script>

<style lang="scss" scoped>
.document-switcher-panel {
  .document-switcher-breadcrumbs {
    max-width: 420px;
    min-height: 44px;
  }
  .view-customer-button {
    width: 100%;
  }
}
</style>
